import {Optional} from "@opendaw/lib-std"

export type KitSample = {
    name: string
    uuid: string
    duration: number
}

// Published in https://assets.opendaw.studio/samples/index.json under "openDAW/One Shots".
export namespace DrumKits {
    export const TR808: ReadonlyArray<KitSample> = [
        {name: "TR-808 Bass Drum", uuid: "b50f6f4f-d933-400c-a63a-83b3c2f6c8b2", duration: 3.0},
        {name: "TR-808 Snare Drum", uuid: "0378e25e-6d3f-4db3-a54f-4ae795ca0ff7", duration: 0.5},
        {name: "TR-808 Rim Shot", uuid: "5dd8103f-d6a2-4604-8464-320f9e1c2f1e", duration: 0.25},
        {name: "TR-808 Hand Clap", uuid: "8537b54c-f18a-459f-9f29-a847232a889e", duration: 2.0},
        {name: "TR-808 Closed Hi-Hat", uuid: "bd20b35e-bdde-4dff-860a-a5524d7adbfc", duration: 0.25},
        {name: "TR-808 Open Hi-Hat", uuid: "7fbc4d43-72dc-4fea-a544-b6eb9fe8dcc2", duration: 0.75},
        {name: "TR-808 Cymbal", uuid: "69190cd1-481a-4e9f-930a-dce4c42fc461", duration: 1.5},
        {name: "TR-808 Cowbell", uuid: "bc034fa6-0ac5-40d2-96a4-e04165922294", duration: 1.5},
        {name: "TR-808 Claves", uuid: "210afc07-3e7e-4548-8608-012b82790a31", duration: 0.25},
        {name: "TR-808 Maracas", uuid: "ac1bb797-a90a-4782-8a08-7b249ef18b42", duration: 0.25},
        {name: "TR-808 Hi Tom", uuid: "74426997-2554-4511-8030-92fd4b3e02bb", duration: 1.0},
        {name: "TR-808 Mid Tom", uuid: "3026d15b-2b29-4c14-b1f1-bdd1521fb982", duration: 1.0},
        {name: "TR-808 Low Tom", uuid: "e82935b9-c17f-4348-9e8f-5b18c25da355", duration: 1.0},
        {name: "TR-808 Hi Conga", uuid: "016b3aeb-6a9e-4d70-b298-87251d95a0e8", duration: 0.5},
        {name: "TR-808 Mid Conga", uuid: "50da4fe7-f2e5-4173-930a-6c3bd18ebe03", duration: 0.5},
        {name: "TR-808 Low Conga", uuid: "5170fed0-42dd-4e27-ad8e-c6f28f7a385f", duration: 0.5}
    ]

    export const TR909: ReadonlyArray<KitSample> = [
        {name: "909 Bassdrum", uuid: "8bb2c6e8-9a6d-4d32-b7ec-1263594ef367", duration: 0.509},
        {name: "909 Snare", uuid: "0017fa18-a5eb-4d9d-b6f2-e2ddd30a3010", duration: 0.235},
        {name: "909 Rimshot", uuid: "cfee850b-7658-4d08-9e3b-79d196188504", duration: 0.150},
        {name: "909 Clap", uuid: "32a6f36f-06eb-4b84-bb57-5f51103eb9e6", duration: 0.507},
        {name: "909 Closed Hat", uuid: "e0ac4b39-23fb-4a56-841d-c9e0ff440cab", duration: 0.154},
        {name: "909 Open Hat", uuid: "51c5eea4-391c-4743-896a-859692ec1105", duration: 0.502},
        {name: "909 Ride", uuid: "87cde966-b799-4efc-a994-069e703478d3", duration: 1.720},
        {name: "909 Crash", uuid: "42a56ff6-89b6-4f2e-8a66-5a41d316f4cb", duration: 1.055},
        {name: "909 High Tom", uuid: "ad503883-8a72-46ab-a05b-a84149953e17", duration: 0.511},
        {name: "909 Mid Tom", uuid: "21f92306-d6e7-446c-a34b-b79620acfefc", duration: 0.385},
        {name: "909 Low Tom", uuid: "28d14cb9-1dc6-4193-9dd7-4e881f25f520", duration: 0.509}
    ]

    export const byUuid = (uuid: string): Optional<KitSample> =>
        TR808.concat(TR909).find(sample => sample.uuid === uuid)
}
